var LinkPreviewData_Styles_Position = /* @__PURE__ */ ((LinkPreviewData_Styles_Position2) => {
  LinkPreviewData_Styles_Position2["START"] = "START";
  LinkPreviewData_Styles_Position2["END"] = "END";
  LinkPreviewData_Styles_Position2["TOP"] = "TOP";
  LinkPreviewData_Styles_Position2["HIDDEN"] = "HIDDEN";
  LinkPreviewData_Styles_Position2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return LinkPreviewData_Styles_Position2;
})(LinkPreviewData_Styles_Position || {});
export {
  LinkPreviewData_Styles_Position
};
//# sourceMappingURL=plugin_link_preview.enums.js.map
